export default "__VITE_ASSET__Ds6Pzfm$__"